module.exports = __webpack_public_path__ + "static/img/bottom.4d7fe61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cvscf2023/bottom.png
// module id = 9CUF
// module chunks = 4